import React from 'react';
import { Link } from 'react-router-dom';
import {
    FiLayers,
    FiUsers,
    FiSettings,
    FiArrowLeftCircle,
    FiArrowRightCircle,
    FiChevronDown,
    FiChevronRight,
    FiBookOpen,
    FiChevronUp,
    FiExternalLink
} from 'react-icons/fi';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import ReactModalActions from 'components/ReactModalActions';
import H1 from 'components/H1';
import NiceWrapper from 'components/NiceWrapper';
import { Box, Flex, Button } from 'rebass';
import { Label, Textarea } from '@rebass/forms';
import config from 'config';
import auth from 'services/auth';
import { HeaderLink, HeaderButton, HeaderAccount } from './HeaderLink';
import NavBar from './NavBar';
import { EVENT_API_DOWN, MESSAGE_API_DOWN, EVENT_API_LOGGED_OUT } from 'utils/constants';
import EventEmitter from 'utils/events';
import helpers from 'utils/helpers';
import moment from 'moment-timezone';
import xhr from 'xhr.js';
import services from 'services/services';
import OutsideClickHandler from 'react-outside-click-handler';
import NiceModal from '../NiceModal';
import store from 'store';

const FEATURE_UPDATES_CACHE_KEY = 'pfx_feat_up';

const FEATURE_UPDATES = [
    {
        title: 'Restrict by country & Survey quotas',
        points: [
            <>
                Allow respondents from specific countries,{' '}
                <a href="#" data-beacon-article="630796be007d42378db77981">
                    read more
                </a>
            </>,
            <>
                Max responses quota,{' '}
                <a href="#" data-beacon-article="6306a79ab67994108536aaf4">
                    read more
                </a>
            </>
        ],
        timestamp: 1661442392902
    },
    {
        title: 'Catching Fraud: IP & Country',
        points: ['IP and Country shown for new panel registrations', 'New training videos added'],
        video_link: 'https://www.loom.com/share/ba191666d13344eca85652bcda0db088',
        video_thumb: 'https://cdn.loom.com/sessions/thumbnails/ba191666d13344eca85652bcda0db088-with-play.gif',
        timestamp: 1658596121000
    },
    {
        title: 'Screener Partials!',
        points: ['aka Screener Incompletes', 'Custom "other" answer choice'],
        video_link: 'https://www.loom.com/share/7c4c741e69374ddba65c20c8b3758941',
        video_thumb: 'https://cdn.loom.com/sessions/thumbnails/7c4c741e69374ddba65c20c8b3758941-with-play.gif',
        timestamp: 1657920191000
    },
    {
        title: 'Undo, Randomize, and Video',
        points: ['Screener undo/redo, versions', 'Randomize answer options', 'Video Recording in Beta'],
        video_link: 'https://www.loom.com/share/b14a8587fc0347189230826d63885db3',
        video_thumb: 'https://cdn.loom.com/sessions/thumbnails/b14a8587fc0347189230826d63885db3-with-play.gif',
        timestamp: 1653760474000
    },
    {
        title: 'New Panel Filtering',
        points: ['Filter goups & "or"'],
        video_link: 'https://www.loom.com/share/49f8fa341c3c43ada20156c79249757c',
        video_thumb: 'https://cdn.loom.com/sessions/thumbnails/49f8fa341c3c43ada20156c79249757c-with-play.gif',
        timestamp: 1651328635927
    },
    {
        title: 'Updated Screener Builder',
        points: ['Easy overview', 'Required is ON'],
        video_link: null,
        video_thumb: null,
        timestamp: 1651328635927
    }
];
const greenCircle = props => {
    props = props || {};
    let margin = props.margin ? props.margin : 0;
    return (
        <span
            className="fill-green"
            style={{
                display: 'inline-block',
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                verticalAlign: 'top',
                margin: margin
            }}
        ></span>
    );
};

/*const HeaderWrapper = styled.div`
    display: flex;
    height: 100vh;
    left: 0px;
    position: sticky;
    top: 0px;
    z-index: 2;
`;*/

const HeaderWrapper = styled.div`
    display: block;
`;

const HeaderWidthWrapper = styled.div`
    background-color: transparent;
    flex-grow: 1;
    position: relative;
    transition: width 150ms;
    padding: 0 36px;
    border-bottom: 1px solid #e9e9e9;
`;

class Header extends React.Component {
    constructor(props) {
        super(props);

        //console.log(this.props.routeMatch);

        let updates_last_checked = store.get(FEATURE_UPDATES_CACHE_KEY);

        this.state = {
            subMenuExpanded: false,
            updatesExpanded: false,
            helpSubmenuExpanded: false,
            accountSwitcherExpanded: false,
            api_down: false,
            logged_out: false,
            showFeatureUpdatesAlert: false,
            updates_last_checked: updates_last_checked,
            featureUpdates: []
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleSubmenuExpand = this.handleSubmenuExpand.bind(this);
        this.handleUpdatesExpand = this.handleUpdatesExpand.bind(this);
        this.handleHelpExpand = this.handleHelpExpand.bind(this);
        this.accountSwitcherOnMouseEnter = this.accountSwitcherOnMouseEnter.bind(this);
        this.accountSwitcherOnMouseOut = this.accountSwitcherOnMouseOut.bind(this);
        this.accountSwitcherTimeout = null;
        this.submitFeedback = this.submitFeedback.bind(this);
        this.shouldShowFeatureUpdatesAlert = this.shouldShowFeatureUpdatesAlert.bind(this);
    }

    shouldShowFeatureUpdatesAlert(updates_last_checked) {
        //console.log('updates_last_checked', updates_last_checked)
        let showFeatureUpdatesAlert = false;
        if (!updates_last_checked) {
            showFeatureUpdatesAlert = true;
        } else {
            //console.log(FEATURE_UPDATES[0].timestamp, updates_last_checked);
            //console.log(FEATURE_UPDATES[0].timestamp > updates_last_checked);
            if (this.state.featureUpdates[0] && this.state.featureUpdates[0].timestamp > updates_last_checked) {
                showFeatureUpdatesAlert = true;
            }
        }
        return showFeatureUpdatesAlert;
    }

    accountSwitcherOnMouseEnter() {
        if (this.accountSwitcherTimeout) {
            clearTimeout(this.accountSwitcherTimeout);
        }
        this.setState({ accountSwitcherExpanded: true });
    }

    accountSwitcherOnMouseOut() {
        const that = this;
        this.accountSwitcherTimeout = setTimeout(function() {
            that.setState({ accountSwitcherExpanded: false });
        }, 300);
    }

    handleSubmenuExpand() {
        const newVal = !this.state.subMenuExpanded;
        this.setState({ subMenuExpanded: newVal });
    }

    handleUpdatesExpand() {
        const newVal = !this.state.updatesExpanded;
        helpers.storeSave(FEATURE_UPDATES_CACHE_KEY, Date.now());

        const showFeatureUpdatesAlert = this.shouldShowFeatureUpdatesAlert(Date.now());

        this.setState({ updatesExpanded: newVal, showFeatureUpdatesAlert: showFeatureUpdatesAlert });
    }

    handleHelpExpand() {
        const newVal = !this.state.helpSubmenuExpanded;

        this.setState({ helpSubmenuExpanded: newVal });
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);

        EventEmitter.subscribe(EVENT_API_DOWN, data => {
            this.setState({ api_down: true });
        });
        EventEmitter.subscribe(EVENT_API_LOGGED_OUT, data => {
            this.setState({ logged_out: true });
        });

        services.productUpdates().then(res => {
            this.setState({ featureUpdates: res }, () => {
                let showFeatureUpdatesAlert = this.shouldShowFeatureUpdatesAlert(this.state.updates_last_checked);
                this.setState({ showFeatureUpdatesAlert });
            });
        });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target) &&
            !document.getElementById('account-submenu').contains(event.target)
        ) {
            this.setState({ subMenuExpanded: false });
        }
    }

    toggleWidth() {
        const newToggle = this.state.headerExpanded == 'expanded' ? 'collapsed' : 'expanded';
        this.setState({ headerExpanded: newToggle });
    }

    getSelectedAccountName() {
        let an = '';
        this.props.auth.user.accounts.forEach(account => {
            if (account.id == this.props.auth.account.id) {
                an = account.title;
            }
        });
        return an;
    }

    chooseAccount(id) {
        auth.changeAccountId(id);
    }

    renderUpdates() {
        try {
            let ret = '';
            if (this.state.updatesExpanded) {
                const niceWrapperStyle = {
                    position: 'absolute',
                    top: '48px',
                    right: '16px',
                    background: '#fff',
                    height: 'auto',
                    padding: '0',
                    overflow: 'scroll',
                    zIndex: 101,
                    boxShadow:
                        '0px 17px 100px rgba(0, 0, 0, 0.06), 0px 5.125px 30.1471px rgba(0, 0, 0, 0.0390953), 0px 2.12866px 12.5216px rgba(0, 0, 0, 0.03), 0px 0.769896px 4.5288px rgba(0, 0, 0, 0.0209047)',
                    width: '380px'
                };

                const bull = <span className="text-primary">&bull;</span>;
                ret = (
                    <NiceWrapper style={niceWrapperStyle}>
                        <Box
                            className="text-primary"
                            sx={{ padding: '24px', fontSize: '18px', lineHeight: '22px', fontWeight: '600' }}
                        >
                            Panelfox product updates
                        </Box>
                        <hr />

                        <Box sx={{ overflow: 'scroll', maxHeight: 'calc(100vh - 160px)', paddingTop: '16px' }}>
                            {this.state.featureUpdates.map((feature, index) => {
                                return (
                                    <Box
                                        sx={{ padding: '0 24px 16px 24px', lineHeight: '32px' }}
                                        id={`feature-update-${index}-container`}
                                    >
                                        <Flex
                                            className="text-primary bold pointer"
                                            justifyContent="space-between"
                                            onClick={() => {
                                                const el = document.getElementById(`feature-update-${index}-body`);
                                                if (el.style.display === 'none') {
                                                    el.style.display = 'block';
                                                } else {
                                                    el.style.display = 'none';
                                                }
                                            }}
                                        >
                                            <Box>
                                                {feature.timestamp > this.state.updates_last_checked
                                                    ? greenCircle({ margin: '10px 4px 0 0' })
                                                    : ''}{' '}
                                                {feature.title}
                                            </Box>
                                            <Box>
                                                <FiChevronDown style={{ fontSize: '16px' }} />
                                            </Box>
                                        </Flex>
                                        <Box
                                            id={`feature-update-${index}-body`}
                                            style={
                                                feature.timestamp > this.state.updates_last_checked
                                                    ? {}
                                                    : { display: 'none' }
                                            }
                                        >
                                            <ul className="ul-feature-updates">
                                                {feature.points.map(point => {
                                                    return (
                                                        <li className="text-secondary">
                                                            {bull} <span dangerouslySetInnerHTML={{ __html: point }} />
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                            {feature.video_link && feature.video_thumb ? (
                                                <a href={feature.video_link} target="_blank">
                                                    <img
                                                        style={{
                                                            width: '100%',
                                                            border: '1px solid #E7E8F1',
                                                            borderRadius: '4px',
                                                            marginTop: '8px'
                                                        }}
                                                        src={feature.video_thumb}
                                                    />
                                                </a>
                                            ) : (
                                                ''
                                            )}
                                        </Box>
                                    </Box>
                                );
                            })}
                        </Box>
                    </NiceWrapper>
                );
            }
            return (
                <OutsideClickHandler
                    onOutsideClick={() => {
                        this.setState({ updatesExpanded: false });
                    }}
                >
                    {ret}
                </OutsideClickHandler>
            );
        } catch (e) {
            helpers.trackError(e);
        }
    }

    renderHelpSubmenu() {
        try {
            let ret = '';
            if (this.state.helpSubmenuExpanded) {
                const niceWrapperStyle = {
                    position: 'absolute',
                    top: '48px',
                    right: '16px',
                    background: '#fff',
                    height: 'auto',
                    padding: '8px 0',
                    zIndex: 101,
                    boxShadow:
                        '0px 17px 100px rgba(0, 0, 0, 0.06), 0px 5.125px 30.1471px rgba(0, 0, 0, 0.0390953), 0px 2.12866px 12.5216px rgba(0, 0, 0, 0.03), 0px 0.769896px 4.5288px rgba(0, 0, 0, 0.0209047)',
                    width: '180px'
                };

                const bull = <span className="text-primary">&bull;</span>;
                ret = (
                    <NiceWrapper style={niceWrapperStyle}>
                        <HeaderLink
                            target="_blank"
                            to={{ pathname: 'https://docs.panelfox.io' }}
                            className="headerLinkDropdown"
                        >
                            <span className="textStyle">
                                Knowledge Base{' '}
                                <FiExternalLink
                                    style={{
                                        float: 'right',
                                        margin: '3px 0 0 0',
                                        verticalAlign: 'top',
                                        height: '14px'
                                    }}
                                />
                            </span>
                        </HeaderLink>
                        <HeaderLink
                            className="headerLinkDropdown"
                            target="_blank"
                            to={{ pathname: 'https://www.youtube.com/channel/UCUuWpCjQBq1mIXPWyRGkaoA/playlists' }}
                        >
                            <span className="textStyle">
                                Training Videos{' '}
                                <FiExternalLink
                                    style={{
                                        float: 'right',
                                        margin: '3px 0 0 0',
                                        verticalAlign: 'top',
                                        height: '14px'
                                    }}
                                />
                            </span>
                        </HeaderLink>
                        <HeaderButton
                            className="headerLinkDropdown"
                            onClick={() => {
                                helpers.openSupportChat();
                            }}
                        >
                            Contact Us
                        </HeaderButton>
                    </NiceWrapper>
                );
            }
            return (
                <OutsideClickHandler
                    onOutsideClick={() => {
                        this.setState({ helpSubmenuExpanded: false });
                    }}
                >
                    {ret}
                </OutsideClickHandler>
            );
        } catch (e) {
            helpers.trackError(e);
        }
    }

    renderSubmenu() {
        const baseURL = config.API_URL;

        const accounts = this.props.auth.user.accounts
            .sort((a, b) => a.title.localeCompare(b.title))
            .map(account => {
                if (account.id == this.props.auth.account.id) {
                    return (
                        <HeaderButton
                            key={account.id}
                            className="nav-item-active headerLinkDropdown"
                            onClick={() => {
                                this.chooseAccount(account.id);
                            }}
                        >
                            {account.title}
                        </HeaderButton>
                    );
                }
                return (
                    <HeaderButton
                        key={account.id}
                        onClick={() => {
                            this.chooseAccount(account.id);
                        }}
                        variant="secondary"
                        className="headerLinkDropdown"
                    >
                        {account.title}
                    </HeaderButton>
                );
            });

        const niceWrapperStyle = {
            position: 'absolute',
            top: '48px',
            right: '36px',
            background: '#fff',
            height: 'auto',
            padding: 0,
            overflow: 'visible',
            zIndex: 101
        };
        let ret = '';
        if (this.state.subMenuExpanded) {
            ret = (
                <NiceWrapper style={niceWrapperStyle} ref={this.setWrapperRef}>
                    <Flex
                        style={{
                            padding: '16px 40px 16px 16px',
                            background: '#F6F6F6',
                            borderTopLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                            maxWidth: '260px'
                        }}
                    >
                        {this.props.auth.user.avatar && (
                            <Box mr={2} flexShrink={0}>
                                <img
                                    src={this.props.auth.user.avatar}
                                    style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '50%'
                                    }}
                                    alt="Avatar"
                                />
                            </Box>
                        )}
                        <Box sx={{ whiteSpace: 'nowrap', lineHeight: '16px' }}>
                            <div className="text-primary fs-14 ellipsis">{this.props.auth.user.name}</div>
                            <div className="text-secondary fs-12 ellipsis">{this.props.auth.user.email}</div>
                            <div className="text-secondary fs-12 ellipsis">{this.props.auth.account.title}</div>
                        </Box>
                    </Flex>

                    <HeaderLink to="/me" className="headerLinkDropdown" style={{ marginTop: '8px' }}>
                        <span className="textStyle">User Settings</span>
                    </HeaderLink>

                    {/* <HeaderLink to="/billing">
                        <span className="textStyle">Plan and billing</span>
                    </HeaderLink>

                    <HeaderLink to="/settings">
                        <span className="textStyle">Organization Settings</span>
                    </HeaderLink> */}

                    {this.props.auth.user.accounts.length > 1 ? (
                        <HeaderButton
                            className="link-accountSwitcher headerLinkDropdown"
                            onMouseEnter={this.accountSwitcherOnMouseEnter}
                            onMouseLeave={this.accountSwitcherOnMouseOut}
                        >
                            <span className="textStyle">Switch organization</span>
                            <span className="iconEnd">
                                <FiChevronRight style={{ strokeWidth: '1.5px' }} />
                            </span>
                            {this.state.accountSwitcherExpanded ? (
                                <NiceWrapper className="accountSwitcher">{accounts}</NiceWrapper>
                            ) : (
                                ''
                            )}
                        </HeaderButton>
                    ) : (
                        ''
                    )}

                    <HeaderButton
                        className="headerLinkDropdown"
                        style={{ color: 'red', marginBottom: '8px' }}
                        onClick={() => {
                            window.Beacon('logout');
                            auth.clearStorage();
                            window.location = `${baseURL}/logout`;
                        }}
                    >
                        Logout
                    </HeaderButton>
                </NiceWrapper>
            );
        }
        return ret;
    }

    submitFeedback(e) {
        e.preventDefault();

        const email = this.props.auth.user.email;
        const message = document.getElementById('feedback-message').value;

        xhr.post(`/collect-feedback`, { email, message }, { withCredentials: true })
            .then(() => {
                alert('Thank you!');
                this.setState({ showModalFeedback: false });
            })
            .catch(error => {
                const errorText = services.parseAndTrackXhrErrors(error);
                alert(errorText);
            });
    }

    render() {
        //console.log('header', this.props)

        let unreadUpdates = 1;

        const days_until_trial_expires = helpers.daysUntilTrialExpires(this.props.auth.account);

        return (
            <>
                {this.state.api_down == true ? (
                    <Box fontSize={1} className="bg-error sticky-top-banner" p={3} px={4} sx={{ color: 'white' }}>
                        {MESSAGE_API_DOWN}
                    </Box>
                ) : (
                    <></>
                )}
                {this.state.logged_out == true ? (
                    <Box fontSize={1} className="bg-warning sticky-top-banner" p={3} px={4} sx={{ color: 'black' }}>
                        Your login session has expired, please <a href={`/login`}>Log In</a> again.
                    </Box>
                ) : (
                    <></>
                )}
                {helpers.isTrialExpired(this.props.auth.account) == true ? (
                    <Box
                        fontSize={1}
                        className="bg-warning sticky-top-banner"
                        p={3}
                        px={4}
                        sx={{ color: 'black', fontWeight: '600' }}
                    >
                        Your trial has expired - please contact{' '}
                        <a href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</a> to upgrade or extend.
                    </Box>
                ) : (
                    <></>
                )}
                <HeaderWrapper>
                    <HeaderWidthWrapper>
                        <NavBar>
                            <Flex>
                                {/* <HeaderLink to="/settings">
                                    <span className="iconWrapper">
                                        <FiUserPlus />
                                    </span>
                                    <span className="textStyle">Recruit</span>
                                </HeaderLink>
                                <HeaderLink to="/dashboard">
                                    <span className="iconWrapper">
                                        <FiHome />
                                    </span>
                                    <span className="textStyle">Home</span>
                                </HeaderLink> */}

                                <HeaderButton
                                    to="/studies"
                                    style={{ marginLeft: 0, marginRight: '36px', paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <Link to="/">
                                        <svg
                                            style={{ marginLeft: '-3px' }}
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M5.57088 0.473601C5.17891 0.114297 4.54683 0.392355 4.54683 0.924084V5.49931C4.54683 5.62105 4.58204 5.7665 4.69151 5.89402C4.85637 6.08607 5.90857 7.30332 7.09635 8.47568C7.30981 8.68637 7.52907 8.89703 7.74957 9.101C7.73911 9.1245 7.72687 9.15073 7.71274 9.1792C7.64456 9.3166 7.53504 9.50077 7.37218 9.68403C7.05559 10.0403 6.52541 10.4101 5.63527 10.4101C4.36385 10.4101 3.80088 9.63844 3.57845 9.20838C3.43721 8.93533 3.15912 8.85707 2.96283 8.87275C2.76412 8.88862 2.47447 9.02046 2.40202 9.35422C2.12729 10.6198 2.15496 11.9343 2.48522 13.1903C2.84816 14.5705 3.56402 15.8326 4.56244 16.8524C5.56087 17.8721 6.80748 18.6146 8.17973 19.0066C9.55199 19.3987 11.0027 19.4269 12.3891 19.0885C13.7756 18.7501 15.0501 18.0567 16.0874 17.0765C17.1248 16.0964 17.8892 14.8631 18.3055 13.498C18.4958 12.874 18.6104 12.2323 18.6487 11.5865L18.6507 11.5785L18.6492 11.5782C18.6939 10.8139 18.6317 10.0439 18.462 9.29074C18.1609 7.9548 17.407 6.55706 16.5094 5.52184C16.5097 5.51467 16.5098 5.50758 16.5098 5.50057V0.938443C16.5098 0.394002 15.8515 0.121343 15.4666 0.506322L13.8888 2.0841C11.5173 1.32494 9.55565 1.29703 7.32499 2.08153L5.57088 0.473601ZM15.9283 6.41533C15.4961 6.92137 14.809 7.70393 14.0636 8.46768C13.492 9.05331 12.875 9.63942 12.3053 10.0827C12.0207 10.3041 11.7367 10.4988 11.4673 10.6402C11.2081 10.7764 10.9125 10.8903 10.618 10.8903C10.3248 10.8903 10.0275 10.7772 9.76548 10.6422C9.4927 10.5017 9.2029 10.3081 8.911 10.0874C8.78907 9.99524 8.66484 9.89684 8.53918 9.79351C8.44234 9.96402 8.30996 10.1621 8.1335 10.3606C7.85282 10.6764 7.46488 10.9876 6.94725 11.1919C6.8306 12.4403 7.24297 13.4922 7.96356 14.2969C8.76255 15.1892 9.95468 15.7902 11.2535 15.9772C12.5496 16.1639 13.9218 15.9338 15.0778 15.204C16.2068 14.4913 17.163 13.281 17.6369 11.4342C17.6668 10.7923 17.6108 10.1467 17.4684 9.51467C17.2287 8.45095 16.6426 7.3084 15.9283 6.41533ZM5.56535 5.34748V1.85022L6.8187 2.99912C6.99083 3.15691 7.23437 3.20022 7.44655 3.12088C9.60631 2.31328 11.4341 2.33018 13.8039 3.12827C14.0207 3.20129 14.2652 3.1481 14.4319 2.98139L15.4913 1.92201V5.35374C15.1854 5.72141 14.3094 6.75767 13.3347 7.75628C12.7761 8.32861 12.1963 8.87704 11.6798 9.27882C11.4213 9.47996 11.1899 9.63545 10.9937 9.7385C10.7874 9.84688 10.6672 9.87181 10.618 9.87181C10.5676 9.87181 10.4442 9.84614 10.2319 9.73676C10.0302 9.6329 9.79187 9.47657 9.52527 9.275C8.99278 8.87239 8.39183 8.32326 7.81184 7.75079C6.8009 6.75298 5.88682 5.71743 5.56535 5.34748ZM15.6215 16.0653C15.654 16.0448 15.6863 16.024 15.7185 16.0028C15.6122 16.1173 15.5019 16.2285 15.3879 16.3362C14.4791 17.195 13.3624 17.8025 12.1476 18.099C10.9329 18.3955 9.66185 18.3708 8.45954 18.0273C7.25723 17.6838 6.165 17.0333 5.29022 16.1398C4.41545 15.2463 3.78824 14.1406 3.47025 12.9313C3.25972 12.1306 3.18953 11.3028 3.25963 10.4841C3.74206 10.9738 4.49794 11.4287 5.63527 11.4287C5.7302 11.4287 5.82255 11.4255 5.91238 11.4194C5.8632 12.8244 6.36626 14.0399 7.20478 14.9764C8.18306 16.0689 9.6037 16.7687 11.1083 16.9853C12.6157 17.2024 14.2375 16.939 15.6215 16.0653Z"
                                                fill="#222222"
                                            />
                                        </svg>
                                    </Link>
                                </HeaderButton>

                                <HeaderLink to="/studies" style={{ marginRight: '32px' }}>
                                    <span className="textStyle">Studies</span>
                                </HeaderLink>
                                <HeaderLink
                                    to="/panel"
                                    style={{ marginRight: '32px' }}
                                    isActive={(match, location) => {
                                        return (
                                            match ||
                                            helpers.startsWithAny(
                                                ['/panels', '/panel-data', '/panel-incentives'],
                                                location.pathname
                                            )
                                        );
                                    }}
                                >
                                    <span className="textStyle">Panels</span>
                                </HeaderLink>
                                <HeaderLink to="/settings">
                                    <span className="textStyle">Settings</span>
                                </HeaderLink>
                                {/* <HeaderLink to="/search">
                                    <span className="iconWrapper">
                                        <FiSearch />
                                    </span>
                                    <span className="textStyle">Search</span>
                                </HeaderLink> */}
                            </Flex>
                            <Flex>
                                {days_until_trial_expires !== false && (
                                    <HeaderButton
                                        style={{ marginRight: '40px' }}
                                        onClick={() => {
                                            window.Beacon('open');
                                            window.Beacon('navigate', '/ask/'); // Ask screen
                                        }}
                                    >
                                        <u>
                                            {days_until_trial_expires} {days_until_trial_expires == 1 ? 'day' : 'days'}{' '}
                                            left in your trial
                                        </u>
                                    </HeaderButton>
                                )}

                                <Box sx={{ position: 'relative' }}>
                                    <HeaderButton
                                        onClick={this.handleUpdatesExpand}
                                        id="updates-submenu"
                                        style={{ marginRight: '32px' }}
                                    >
                                        <span className="textStyle">
                                            {this.state.showFeatureUpdatesAlert && unreadUpdates
                                                ? greenCircle({ margin: '4px 4px 0 0' })
                                                : ''}
                                            Updates
                                            <FiChevronDown
                                                style={{
                                                    margin: '3px 0 3px 4px',
                                                    verticalAlign: 'top',
                                                    width: '16px'
                                                }}
                                            />
                                        </span>
                                    </HeaderButton>
                                    {this.renderUpdates()}
                                </Box>

                                <Box sx={{ position: 'relative' }} ml={1}>
                                    <HeaderButton
                                        onClick={this.handleHelpExpand}
                                        id="updates-submenu"
                                        style={{ marginRight: '32px' }}
                                    >
                                        <span className="textStyle">
                                            Help
                                            <FiChevronDown
                                                style={{ margin: '3px 0 3px 4px', verticalAlign: 'top', width: '16px' }}
                                            />
                                        </span>
                                    </HeaderButton>
                                    {this.renderHelpSubmenu()}
                                </Box>

                                <HeaderButton onClick={this.handleSubmenuExpand} id="account-submenu">
                                    <Flex ml={2} style={{ justifyContent: 'space-between', width: '100%' }}>
                                        <Flex>
                                            {this.props.auth.user.avatar ? (
                                                <Box mr={2}>
                                                    <img
                                                        src={this.props.auth.user.avatar}
                                                        style={{
                                                            width: '24px',
                                                            height: '24px',
                                                            borderRadius: '50%'
                                                        }}
                                                    />
                                                </Box>
                                            ) : (
                                                <></>
                                            )}

                                            {/*(
                                                    <Box style={{
                                                                width: '24px',
                                                                height: '24px',
                                                                borderRadius: '50%',
                                                                background: '#fff',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                        {this.props.auth.user.name.split('')[0]}
                                                    </Box>
                                                )*/}
                                            <Box flexShrink={0} className="ellipsis" lineHeight="24px">
                                                {this.props.auth.user.name}
                                            </Box>
                                        </Flex>
                                        <FiChevronDown
                                            style={{ margin: '3px 0 3px 4px', verticalAlign: 'top', width: '16px' }}
                                        />

                                        {/*<Box className="accountInitial">
                                            {this.props.auth.account.logo ? (
                                                <img
                                                    src={this.props.auth.account.logo}
                                                    style={{ width: '32px' }}
                                                    alt="Logo"
                                                />
                                            ) : (
                                                <div
                                                    style={{
                                                        background: 'black',
                                                        height: '100%',
                                                        width: '100%',
                                                        padding: '5px 0 0 0'
                                                    }}
                                                >
                                                    {this.props.auth.account.title.split('')[0]}
                                                </div>
                                            )}
                                        </Box>
                                        <Box>
                                            <Flex style={{ fontSize: '14px', color: '#444', maxWidth: '100%' }}>

                                            </Flex>
                                        </Box>*/}
                                    </Flex>
                                </HeaderButton>
                                {/*<HeaderButton
                                    onClick={() => {
                                        this.toggleWidth(this);
                                    }}
                                >
                                    <span className="iconWrapper">
                                        {this.state.headerExpanded == 'expanded' ? (
                                            <FiArrowLeftCircle />
                                        ) : (
                                            <FiArrowRightCircle />
                                        )}
                                    </span>
                                    <span className="textStyle">Collapse</span>
                                </HeaderButton>*/}
                            </Flex>
                        </NavBar>
                    </HeaderWidthWrapper>
                    {this.renderSubmenu()}
                </HeaderWrapper>

                <NiceModal
                    isOpen={this.state.showModalFeedback}
                    shouldCloseOnOverlayClick
                    onRequestClose={() => this.setState({ showModalFeedback: false })}
                    style={{ content: { width: 'auto', maxWidth: '1100px' } }}
                    title="Contact Us"
                >
                    <Box>
                        <Box mb={3} className="text-secondary">
                            We love making your life easier, so please let us know how we can help.
                            <br />
                            You can also email <a href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</a>.
                        </Box>
                        <Textarea
                            mb={1}
                            id="feedback-message"
                            autoFocus={1}
                            className="theme-input"
                            sx={{ minHeight: '160px' }}
                        />
                    </Box>
                    <Box className="modal-actions">
                        <Button
                            type="button"
                            variant="secondary-gray"
                            mr={3}
                            onClick={() => {
                                this.setState({ showModalFeedback: false });
                            }}
                        >
                            Cancel
                        </Button>

                        <Button type="submit" variant="primary" sx={{ marginRight: 0 }} onClick={this.submitFeedback}>
                            Send
                        </Button>
                    </Box>
                </NiceModal>
            </>
        );
    }
}

export default Header;
